import {Route} from 'vue-router';

export interface AccountSettings {
  canOpen: boolean;
}

export interface EnterpriseSettings {
  enterpriseId: number;
  features: string[];
}

export interface GoalSettings {
  canBeModified: boolean;
}

export interface RouteGuardSettings {
  account: AccountSettings;
  enterprise: EnterpriseSettings;
  goal: GoalSettings;
}

// eslint-disable-next-line unicorn/no-static-only-class
export default class RouteGuard {
  static isRouteValid(to: Route, settings: RouteGuardSettings): boolean {
    let canAccess = true;

    const protectedRoutes = [
      // routes blocked by segment settings
      {
        names: ['AddGoal', 'GoalAllocationPage'],
        canAccess: settings.goal.canBeModified,
      },
      {
        names: ['AddAccount', 'AddAccountPage', 'ApexAddAccountPage'],
        canAccess: settings.account.canOpen,
      },
      // if enterprise sso is enabled, disable these routes
      {
        names: ['Login', 'ForgotPassword', 'UserProfile', 'VerifyUser', 'VerifyIdentity'],
        canAccess: !(settings.enterprise.enterpriseId !== null && settings.enterprise.features.includes('SSO')),
      },
    ];

    const matchedRoute = protectedRoutes.find((routes) => routes.names.includes(to.name));

    if (matchedRoute) {
      canAccess = matchedRoute.canAccess;
    }

    return canAccess;
  }
}
